/* eslint-disable @typescript-eslint/no-non-null-assertion */
/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */

// import { Constructor } from '../../core/lib';
// import { deserialize } from '@aaf/serialization';
import { Headers } from './Headers';

/**
 * A class to manipulate request and response bodies.
 */
export class Body {
    private used = false;
    private text?: string;
    private json?: Record<string, unknown>;
    private formData?: FormData;
    private arrayBuffer?: ArrayBuffer;

    /**
     * Create a Body.
     *
     * @param headers HTTP headers for the request/response.
     * @param data The data of the body.
     */
    constructor(headers: Headers, data?: string | FormData | Record<string, unknown> | ArrayBuffer) {
        if (!data) {
            this.text = '';
        } else if (typeof data === 'string') {
            this.text = data;
        } else if (data instanceof FormData) {
            this.formData = data;
            if (headers.get('Content-Type')) {
                headers.delete('Content-Type');
            }
        } else if(data instanceof ArrayBuffer){
            this.arrayBuffer = data;
        } else {
            const type = headers.get('Content-Type');
            switch (type) {
                case 'text/json':
                case 'application/json':
                    this.json = data;
                    break;
                default:
                    this.text = Object.prototype.toString.call(data);
            }
        }
    }

    /**
     * Read the body as text.
     * If the body is from a multipart request/response this will throw.
     *
     * @returns The body encoded as UTF-8 text.
     * @throws {Error} When trying to read the same body twice.
     * @throws {Error} When trying to read a multipart body as text.
     */
    public async asText(): Promise<string> {
        await this.consume();

        if (this.json) {
            return JSON.stringify(this.json);
        }
        if (this.formData) {
            throw new Error('Cannot read FormData as text');
        }
        return this.text!;
    }

    /**
     * Read the body as JSON.
     * This will try to parse the body as JSON and return a key-value object.
     *
     * @returns An JavaScript object representing a JSON.
     */
    public asJSON(): Promise<Record<string, unknown>> {
        if (this.json) return Promise.resolve(this.json);
        return Promise.resolve(JSON.parse(this.text!));
    }

    /**
     * Read the body as JSON
     *
     * @param cls
     * @param validate
     */
    // TODO implementar despues por ahora no es necesario 
    // public async asClass<T>(cls: Constructor<T>, validate = true): Promise<T> {
    //     const json = await this.asJSON();
    //     return deserialize(cls, json, { validate });
    // }

    public asFormData(): Promise<FormData> {
        if (!this.formData) {
            return Promise.reject(new Error('Cannot read body as FormData'));
        }
        return Promise.resolve(this.formData);
    }

    public asArrayBuffer(): Promise<ArrayBuffer> {
        if (!this.arrayBuffer) {
            return Promise.reject(new Error('Cannot read body as ArrayBuffer'));
        }
        return Promise.resolve(this.arrayBuffer);
    }

    // eslint-disable-next-line consistent-return
    private consume(): void | Promise<never> {
        if (this.used) {
            return Promise.reject(new TypeError('Body already read'));
        }
        this.used = true;
    }
}



// WEBPACK FOOTER //
// ./src/packages/http/lib/Body.ts